module.exports = __webpack_public_path__ + "assets/images/bagarrowleft-off.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bagarrowleft-off.png
// module id = 399
// module chunks = 1